import { lazy, Suspense, useEffect, useState } from "react";
import BlaBlaHead from "../blabla/BlaBlaHead";
import BlaBlaMission from "../blabla/BlaBlaMission";

const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const BlaBlaAction = lazy(() => import("../blabla/BlaBlaAction"));
const BlaBlaAllin = lazy(() => import("../blabla/BlaBlaAllin"));
const BlaBlaBusiness = lazy(() => import("../blabla/BlaBlaBusiness"));
const BlaBlaFeature = lazy(() => import("../blabla/BlaBlaFeature"));
const BlaBlaMinimum = lazy(() => import("../blabla/BlaBlaMinimum"));
const BlaBlaTech = lazy(() => import("../blabla/BlaBlaTech"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));

const HeadData = {
  title: "Launch a Modern Carpooling App Like Poparide",
  description: "Empower Canadians to share long-distance rides with ease and affordability. Our feature-packed, customizable carpooling solution helps you launch a Poparide-style app tailored to local commuting needs and regional travel across Canada.",
  image: "/assets/home/blabla-banner.webp",
  backImage: "/assets/home/blabla-banner-back.webp",
  btn: "Schedule A Demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "poparide Clone App",
        slug: ""
      },
    ]
  }
};

const missionData = {
  mission: "Our Mission",
  titlePart1: "Reliable Mobility Tech",
  titlePart2: "Built for",
  titlePart3: "Canada",
  description: "With 5+ years of mobility tech experience and a legacy that started in 2009, Mobility Infotech specializes in scalable, sustainable ride-sharing solutions. We enable local transport entrepreneurs to go digital, stay independent, and grow their user base across Canadian cities and provinces — from Vancouver to Montreal.",
}

const businessData = {
  titlePart1: "Versatile ",
  titlePart2: "Ride-Sharing Tech",
  titlePart3: "for All Transportation Models",
  description: "Our carpooling technology is flexible and optimized for a variety of ride-sharing concepts:",
  boxes: [
    {
      image: "/assets/home/blabla-business-icon1.webp",
      heading: "Intercity Carpooling Marketplace",
      description: "Launch your own Poparide-style app to help Canadians share long-distance rides — perfect for students, commuters, and travelers looking to save money, reduce emissions, and split fuel costs.",
    },
    {
      image: "/assets/home/blabla-business-icon2.webp",
      heading: "Daily Commute Carpooling",
      description: "Offer a convenient solution for employees and city residents to share daily office commutes. Reduce congestion, cut down costs, and promote eco-conscious commuting in urban centers.",
    },
    {
      image: "/assets/home/blabla-business-icon3.webp",
      heading: "peer-to-peer Ride Matching",
      description: "Create a community-driven platform where passengers and drivers can easily connect for trips headed in the same direction — with built-in trust, transparency, and seamless coordination.",
    },
  ]
}

const featureData = {
  titlePart1: "Poparide",
  titlePart2: "Clone App",
  titlePart3: "Features",
  description: "Our white-label app comes fully loaded with everything you need to start your own successful carpooling business in Canada:",
  boxes: [
    {
      image: "/assets/home/bla-feature-1.webp",
      heading: "Simple Sign-Up",
      description: "Join with email or social login in seconds.",
    },
    {
      image: "/assets/home/bla-feature-2.webp",
      heading: "Smart Ride Finder",
      description: "Search and book available seats for upcoming trips based on route and schedule.",
    },
    {
      image: "/assets/home/bla-feature-3.webp",
      heading: "Filter by Ride Type",
      description: "Choose preferences like private/shared, driver rating, or vehicle comfort.",
    },
    {
      image: "/assets/home/bla-feature-4.webp",
      heading: "Instant Ride Matching",
      description: "AI-based engine connects riders and drivers with compatible routes.",
    },
    {
      image: "/assets/home/bla-feature-5.webp",
      heading: "Transparent Cost Estimate",
      description: "Clear view of fare breakdown and travel duration before booking.",
    },
    {
      image: "/assets/home/bla-feature-6.webp",
      heading: "Push Notifications",
      description: "Real-time updates for ride bookings, messages, and reminders.",
    },
    {
      image: "/assets/home/bla-feature-7.webp",
      heading: "GPS-Based Tracking",
      description: "Live trip tracking using Google Maps ensures security and accurate pickups.",
    },
    {
      image: "/assets/home/bla-feature-8.webp",
      heading: "Route Navigation",
      description: "Integrated navigation helps drivers follow the best route with minimal detours.",
    },
    {
      image: "/assets/home/bla-feature-9.webp",
      heading: "Ratings & Feedback",
      description: "Riders and drivers can leave ratings and reviews after each trip.",
    },
    {
      image: "/assets/home/bla-feature-10.webp",
      heading: "Secure Payments",
      description: "Multiple payment options, including Stripe, PayPal, Interac, and more.",
    },
    {
      image: "/assets/home/bla-feature-11.webp",
      heading: "VoIP Calling (In-App)",
      description: "In-app calls without sharing personal numbers for enhanced privacy.",
    },
    {
      image: "/assets/home/bla-feature-12.webp",
      heading: "Emergency SOS Function",
      description: "One-tap safety button to alert emergency contacts in case of distress.",
    },
    {
      image: "/assets/home/bla-feature-13.webp",
      heading: "Invite Friends",
      description: "Users can invite friends and earn rewards with referral bonuses.",
    },
    {
      image: "/assets/home/bla-feature-14.webp",
      heading: "Discount Codes",
      description: "Promo code integration to incentivize sign-ups and repeat bookings.",
    },
    {
      image: "/assets/home/bla-feature-15.webp",
      heading: "Driver Availability Toggle",
      description: "Drivers can mark themselves available/unavailable for trips.",
    },
    {
      image: "/assets/home/bla-feature-16.webp",
      heading: "Bilingual Interface",
      description: " Supports both English and French for nationwide reach.",
    },
  ]
}

const techData = {
  titlePart1: "Why Choose ",
  titlePart2: "Mobility Infotech?",
  description: "We don’t just build apps — we build mobility ecosystems. With reliable back-end architecture, real-time features, and growth-ready design, we help you lead the Canadian carpooling revolution.",
  image: "/assets/home/bla-tech-img.webp",
  boxes: [
    {
      image: "/assets/home/bla-tech-icon1.webp",
      heading: "Fully Customizable, Locally Optimized",
      description: "Your app, your brand. From UI design to platform logic, you can customize every element to suit your target region, pricing model, and business goals.",
    },
    {
      image: "/assets/home/bla-tech-icon2.webp",
      heading: "Advanced Tech That Fuels Growth",
      description: "Whether you're enabling weekend getaways or weekday commutes, our Poparide clone app ensures seamless experience, maximum reliability, and long-term retention.",
    },
    {
      image: "/assets/home/bla-tech-icon3.webp",
      heading: "Secure, Scalable Carpooling App",
      description: "Our seasoned development team ensures your carpooling app is secure, future-proof, and built for high-traffic performance – with unmatched support and maintenance.",
    },
    {
      image: "/assets/home/bla-tech-icon4.webp",
      heading: "Built-in Referral & Multi-Payment System",
      description: "Encourage user growth with referral bonuses and accept all major Canadian payment systems for smooth, secure transactions.",
    }
  ]

}

const actionData = {
  imageBack: "/assets/home/bla-action-back.webp",
  title: "Don’t lose touch with your market",
  description: "Advance with confidence partner with Mobility Infotech for future-ready operations.",
  btn: "get in touch"
}

const allInData = {
  titlePart1: "Admin Dashboard – ",
  titlePart2: "Full Platform Control",

  feature1: {
    image: "/assets/home/bla-rider-main.webp",
    leftBoxes: [
      {
        title: "Quick Registration",
        description: "Begin with just an email or social account.",
        image: "/assets/home/bla-rider-1.webp",
      },
      {
        title: "Personalized Profiles",
        description: "Complete profiles to build trust and improve ride matching.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Precise Location Entry",
        description: " Input pickup and drop-off locations with GPS assistance.",
        image: "/assets/home/bla-rider-3.webp",
      },
      {
        title: "Preferred ride Selection",
        description: "Choose based on comfort, type, or number of available seats.",
        image: "/assets/home/bla-rider-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Upfront Pricing",
        description: "Know the trip cost and payment method before you book.",
        image: "/assets/home/bla-rider-5.webp",
      },
      {
        title: "Real-Time Tracking",
        description: "Track the trip live through the app once booked.",
        image: "/assets/home/bla-rider-6.webp",
      },
      {
        title: "SOS for Safety",
        description: "One-tap safety alert built into every trip.",
        image: "/assets/home/bla-rider-7.webp",
      },
      {
        title: "Trusted Reviews",
        description: " Read and submit ratings to build a reliable ride-sharing network.",
        image: "/assets/home/bla-rider-8.webp",
      },
    ],
  },

  feature2: {
    image: "/assets/home/bla-admin-main.webp",
    leftBoxes: [
      {
        title: "Role-Based Access",
        description: "Limit admin/staff permissions based on responsibilities.",
        image: "/assets/home/bla-admin-1.webp",
      },
      {
        title: "User Profile Management",
        description: "Approve, manage, or deactivate rider/driver accounts as needed.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Transaction Reporting",
        description: "Monitor ride payments, payouts, and platform commissions in real time.",
        image: "/assets/home/bla-admin-3.webp",
      },
      {
        title: "car owners Verification",
        description: "Onboard only verified car owners with documentation and approval steps.",
        image: "/assets/home/bla-admin-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Earnings Dashboard",
        description: "Access detailed reports of driver earnings and platform revenue.",
        image: "/assets/home/bla-admin-5.webp",
      },
      {
        title: "Payout History",
        description: "Transparent log of all driver payouts and scheduled transfers.",
        image: "/assets/home/bla-admin-6.webp",
      },
      {
        title: "Feedback Monitoring",
        description: "Review and manage passenger/driver ratings and reports.",
        image: "/assets/home/bla-rider-8.webp",
      },
      {
        title: "Settings & Pricing Control",
        description: "Configure ride pricing, commission structures, and platform rules anytime.",
        image: "/assets/home/bla-admin-8.webp",
      },
    ],
  },
}

const minimumData = {
  tagline: "Why quality matters more than price!",
  titlePart1: "Launch Smarter ",
  titlePart2: "Than an MVP",
  description: "With Mobility Infotech’s Poparide Clone, you launch more than just a basic app. You start with a scalable, feature-rich platform built for real-world usage, daily traffic, and high engagement.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Transparent Development Process",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "Core Features Available from Day One",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Updates with No Hidden Costs",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "UX/UI Optimized for Canadian Users",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Post-Launch Support (Enterprise-Grade)",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "High-Performance & Fail-Safe Backend",
  },
  btn: "SEE OUR PRICING PLAN",
}

const faqData = [
  {
    id: "0",
    question: "01. Is the Poparide Clone customizable for my business model?",
    answer: "Yes, the solution is fully white-labeled and customizable — including app features, design, regional settings, language, and payment integrations.",
  },
  {
    id: "1",
    question: "02. Can I serve both English and French-speaking users in Canada?",
    answer: "Yes, our bilingual support ensures smooth experience across provinces like Quebec, Ontario, and beyond.",
  },
  {
    id: "2",
    question: "03. Is the platform compliant with Canadian privacy laws?",
    answer: "Absolutely. We ensure full PIPEDA compliance and responsible handling of personal data for all users.",
  },
  {
    id: "3",
    question: "04. Can the app handle long-distance and short-distance rides?",
    answer: "Yes, the platform supports all types of shared rides – whether intercity travel or daily commuting.",
  },
  {
    id: "4",
    question: "05. What payment systems are integrated?",
    answer: "We support Stripe, PayPal, Interac e-Transfers, debit/credit cards, and more based on your audience preference.",
  },
  {
    id: "5",
    question: "06. How are users matched?",
    answer: "The platform uses intelligent route-matching algorithms to pair passengers and drivers heading the same way.",
  },
];

export default function PoparideClone() {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <BlaBlaHead data={HeadData} />
      <BlaBlaMission data={missionData} />

      <Suspense fallback={null}>
        {isScroll && (
          <>
            <BlaBlaBusiness data={businessData} />
            <BlaBlaFeature data={featureData} />
            <BlaBlaTech data={techData} />
            <BlaBlaAction data={actionData} />
            <BlaBlaAllin data={allInData} />
            <BlaBlaMinimum data={minimumData} />
            <ShuttleAppreciation />
            <div className="zip-faq-fixer">
              <TaxiFaq faqData={faqData} />
            </div>
          </>
        )}
      </Suspense>
    </>
  )
}
